  
  <div [ngClass]="{'signin-container': !isModalOpened, 'signin-container-modal': isModalOpened}" *ngIf="{ returnUrl: returnUrl$ | async, 
                                         userDoesNotExist: userDoesNotExist$ | async,
                                         isSignInError: isSignInError$ | async} as data">
    <div class="signin">
      <app-spinner [isLoading]="isLoading$ | async" [isFixedPosition]="false">
        <div class="signin-form" [ngClass]="{'signin-form-modal-unopened': !isModalOpened, 'signin-form-modal-opened': isModalOpened}">
          @if (!isModalOpened) {
            <p-tabs class="auth-tabs" [showNavigators]="false" [value]="signInTab" (valueChange)="onTabChange($event)">
              <p-tablist>
                <p-tab [value]="signInTab">{{ 'label.SignIn' | translate }}</p-tab>
                <p-tab [value]="registrationTab">{{ 'label.Registration' | translate }}</p-tab>
              </p-tablist>
            </p-tabs>
          }

          <div class="signin-form-heading" *ngIf="!isModalOpened">
            <p class="signin-form-heading__main">
              {{ 'label.SignIn' | translate }}
            </p>
            <p class="signin-form-heading__comment">
              {{ 'label.ForJobseeker' | translate }}
            </p>
          </div>
    
          <form [formGroup]="submitForm">
            <div class="form-inputs">
            <mat-form-field appearance="outline" class="registration-input">
              <mat-label>{{ 'label.Email' | translate }}</mat-label>
              <input matInput type="email" formControlName="emailInput" />
            </mat-form-field>
    
            <div class="password-container">
            <hrra-password-input formControlName="passwordInput" [withPlaceholder]="true" placeholder="{{'label.Password' | translate}}"></hrra-password-input>
            </div>
            </div>
    
            <div class="signin-checkbox">
              <mat-checkbox formControlName="staySignedInCheckbox">
                {{ 'label.KeepMeSignedIn' | translate }}
              </mat-checkbox>
            </div>
    
            <div class="signin-button">
              <button class="signin-button__btn" (click)="onLoginClick(data.returnUrl)" type="submit">
                {{ 'label.SignIn' | translate }}
              </button>
            </div>
    
            <div class="signin-pwd-recovery">
              <a [routerLink]="['/jobseeker/reset-password']" class="signin-pwd-recovery__link">{{
              'label.ForgotThePassword' | translate
            }}</a>
            </div>
          </form>
          <div *ngIf="data.isSignInError || data.userDoesNotExist"  class="error">
            <app-jobseeker-error-message [messageHeading]="'label.LoginFailed' | translate"
            [message]="'label.LoginFailedMessage' | translate"></app-jobseeker-error-message>
          </div>
        </div>
      </app-spinner>

      <div class="registration" *ngIf="!isModalOpened">
        <div class="registration-container">
          <div class="registration-container__text">{{'label.DontHaveAnaccount' | translate}}</div>
          <a [routerLink]="['/jobseeker/register']" >
            <button class="registration-container__btn">{{'label.CvRegistration' | translate}}</button>
          </a>
        </div>
      </div>
    </div>
    
  
    <div class="recruitment" *ngIf="!isModalOpened">
      <app-jobseeker-recruitment-box></app-jobseeker-recruitment-box>
    </div>
  </div>
